export default __webpack_public_path__ + "locales/de/Files.json?hash=ef626a7fb9d727bdf213b1f5c9ba3d83";